/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import { RangePickerInput } from '@oca/ui';

/**
 *
 * @param {import('react-flatpickr').DateTimePickerProps}
 */
export function RangePickerInputWrapper({
  label,
  input,
  meta,
  helperText,
  required,
  placeholder,
  spaceAfter,
  form,
  disabled,
  ...rest
}) {
  const showError =
    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) &&
    meta.touched;
  const { onChange, onBlur, onFocus, value, name } = input;

  // flatpickr fires selection through a native DOM event. Under React < 18 the
  // resulting final-form setState runs synchronously, re-rendering and calling
  // back into flatpickr (setDate → redraw) WHILE it is still handling the
  // click — which corrupted the first selection and required a second click.
  // Deferring to a microtask lets flatpickr finish before the form updates.
  const handleChange = React.useCallback(
    selectedDates => {
      const next = (selectedDates && selectedDates[0]) || null;
      Promise.resolve().then(() => onChange(next));
    },
    [onChange],
  );

  // flatpickr closes the calendar after selection, which blurs the input and
  // triggers final-form validation synchronously — before the deferred onChange
  // microtask has run. Deferring onBlur too ensures the value is set first,
  // preventing premature "required field" errors on the first click.
  const handleBlur = React.useCallback(() => {
    Promise.resolve().then(() => onBlur && onBlur());
  }, [onBlur]);

  return (
    <RangePickerInput
      // {...rest}
      inputProps={{
        form,
        label,
        disabled,
        onBlur: handleBlur,
        onFocus,
        required,
        placeholder,
        name,
        spaceAfter,
        helperText: showError ? meta.error || meta.submitError : helperText,
        error: showError,
      }}
      onChange={handleChange}
      value={value}
    />
  );
}

RangePickerInputWrapper.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any,
  }).isRequired,
  meta: PropTypes.shape({
    submitError: PropTypes.any,
    dirtySinceLastSubmit: PropTypes.bool,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object,
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  // eslint-disable-next-line react/require-default-props
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  // eslint-disable-next-line react/require-default-props
  required: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  placeholder: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  spaceAfter: PropTypes.bool,
};
